<template>
  <div class="pagination" role="group" aria-label="分页">
      <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[5, 10, 50, 100,500]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
      </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    list: {
      type: Function,
      default: null
    },
    itemCount: Number // 显示的页码数，比如总共有100页，只显示10页，其它用省略号表示
  },
  data: function () {
    return {
      total: 0, // 总行数
      size: 10, // 每页条数
      page: 1, // 当前页码
      pageTotal: 0, // 总页数
      pages: [], // 显示的页码数组
    }
  },
  methods: {

      //跳转到多少页
      handleCurrentChange(num){
          this.list(num)
      },
      //每页显示多少条数据
      handleSizeChange(num){
         this.size=num
          this.list(1)
      },

    render(page, total) {
        this.page=page
        this.total=total
    },

  }
}
</script>

<style scoped>
.pagination {
  vertical-align: middle !important;
  font-size: 16px;
  margin-top: 0.5%;
  /*margin-bottom: 10px;*/
  float: right;
}

.pagination button {
  margin-right: 5px;
}

.btn-primary.active {
  background-color: #2f7bba !important;
  border-color: #27689d !important;
  color: white !important;
  font-weight: 600;
}

</style>